import React from 'react';
import { IEntityDetailsProps } from './detailsTypes';
import { PrimaryDetails } from './PrimaryDetails';
import { SecondaryDetails } from './SecondaryDetails';
import './EntityDetails.less';

export const ENTITY_DETAILS_ID = "ENTITY_DETAILS_ID"

export function EntityDetails(props: IEntityDetailsProps) {
  return (
    <div className="dp-entitydetails">
      {props.entityName && (
        <>
          <PrimaryDetails {...props} />
          <SecondaryDetails {...props} />
        </>
      )}
      {!props.entityName && <div className="dp-entitydetails__loading-message">Loading...</div>}
    </div>
  );
}
